<script>
export default {
  name: 'Promo',
};
</script>

<template>
  <div class="promo main-block">
    <div class="promo__content">
      <h1>{{ $t('launchpad.banner.title') }}</h1>
      <p class="subline">{{ $t('launchpad.banner.subline') }}</p>
      <p v-html="$t('launchpad.banner.text')"></p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.promo {
  height: 38vw;
  padding: 5rem 8rem;
  background: url('../../assets/img/launchpad/launchpad-banner-bg.png') no-repeat bottom
    center / cover, #fff;
  border-radius: 2rem;
  font-size: 1.6rem;
  font-weight: bold;
  width: calc(100% - 3rem);
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  align-items: center;

  body.binance & {
    background: url('../../assets/img/launchpad/launchpad-banner-bg.png') no-repeat bottom
      center / cover, $b-main-bg;
  }

  &__content {
    display: flex;
    flex-direction: column;
    width: 50%;

    h1 {
      font-size: 7rem;
      line-height: 1.3;
      margin-bottom: 3rem;
    }

    p {
      margin-bottom: 3rem;
      font-size: 2.4rem;
    }

    .subline {
      font-size: 3.6rem;
      margin-bottom: 3rem;
    }
  }

  @media screen and (max-width: $breakpoint-sm) {
    background-image: url('../../assets/img/launchpad/launchpad-banner-bg-sm.png');
    background-position: center 57%;
    background-size: 110%;
    height: fit-content;
    padding: 3rem 4rem;

    &__content {
      width: 100%;

      h1 {
        font-size: 2.4rem;
      }

      p {
        font-size: 1.8rem;
        margin-bottom: 42rem;
      }

      .subline {
        font-size: 2.4rem;
      }
    }

    body.binance & {
      background-image: url('../../assets/img/launchpad/launchpad-banner-bg-sm.png');
    }
  }
}
</style>
